import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import PDPImageAndTextOptionDisplay from 'components/consumer/PDP/PDPImageAndTextOptionDisplay';
const PDPImageAndTextSelector = t0 => {
  const $ = _c(8);
  const {
    isEditOrder: t1,
    imageOrTextVariant: t2,
    mode: t3,
    optionId: t4,
    productId: t5,
    slug,
    variant: t6
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const imageOrTextVariant = t2 === undefined ? "regular" : t2;
  const mode = t3 === undefined ? "pdp" : t3;
  const optionId = t4 === undefined ? null : t4;
  const productId = t5 === undefined ? null : t5;
  const variant = t6 === undefined ? "regular" : t6;
  let t7;
  if ($[0] !== imageOrTextVariant || $[1] !== isEditOrder || $[2] !== mode || $[3] !== optionId || $[4] !== productId || $[5] !== slug || $[6] !== variant) {
    t7 = <PDPImageAndTextOptionDisplay hideFlyout={true} isEditOrder={isEditOrder} imageOrTextVariant={imageOrTextVariant} mode={mode} optionId={optionId} productId={productId} slug={slug} variant={variant} />;
    $[0] = imageOrTextVariant;
    $[1] = isEditOrder;
    $[2] = mode;
    $[3] = optionId;
    $[4] = productId;
    $[5] = slug;
    $[6] = variant;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};
PDPImageAndTextSelector.propTypes = {
  imageOrTextVariant: PropTypes.oneOf(['regular', 'textOnly']),
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  optionId: PropTypes.number,
  productId: PropTypes.number,
  slug: PropTypes.string,
  isEditOrder: PropTypes.bool,
  variant: PropTypes.oneOf(['regular', 'fullWidth'])
};
export default PDPImageAndTextSelector;